import { KeyboardDateTimePicker } from '@material-ui/pickers';
import QCXPicker from '../picker/QCXPicker';

export default function QCXDatePicker({
  format = 'DD/MM/YYYY',
  placeholder = 'DD/MM/YYYY',
  disablePast = false,
  disableFuture = false,
  onDoubleClick,
  ...restProps
}) {
  return (
    <QCXPicker>
      <KeyboardDateTimePicker
        InputLabelProps={{
          shrink: true,
          style: {
            textTransform: 'uppercase',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // width: '100%',
          },
        }}
        emptyLabel=""
        format={format}
        placeholder={placeholder}
        inputVariant="outlined"
        size="small"
        fullWidth
        disablePast={disablePast}
        disableFuture={disableFuture}
        onDoubleClick={() => onDoubleClick()}
        {...restProps}
      />
    </QCXPicker>
  );
}
